export const teammatesConstants = {
  GET_TEAMMATE_SUCCESS: 'GET_TEAMMATE_SUCCESS',
  GET_TEAMMATES: 'GET_TEAMMATES',
  GET_TEAMMATES_SUCCESS: 'GET_TEAMMATES_SUCCESS',
  SET_TEAMMATES_TIMESTAMP: 'SET_TEAMMATES_TIMESTAMP',
  DELETE_TEAMMATE: 'DELETE_TEAMMATE',
  UPDATE_TEAMMATE: 'UPDATE_TEAMMATE',
  SET_TEAMMATE_LOADING: 'SET_TEAMMATE_LOADING',
};
